import Cookies from 'js-cookie';

/**
 * Checks if cookies are enabled based on the user accepting or rejecting
 * the CookieYes consent banner.
 * @returns `true` if the user has accepted cookies
 * @returns `false` if the user has rejected cookies
 * @returns `undefined` if the CookieYes banner is disabled or the website is suspended
 * @see https://www.cookieyes.com/documentation/retrieving-consent-data-using-api-getckyconsent/
 */
const areCookiesEnabled = (): boolean | undefined => {
  if (!window.getCkyConsent) {
    return;
  }

  const consentData = window.getCkyConsent();

  return consentData.isUserActionCompleted && consentData.categories.functional;
};

export const setCookie = (name: string, value: string, options?: Cookies.CookieAttributes): string | undefined => {
  // only check if cookies are not enabled
  // the user may be coming to the site for the first time
  // and we need to make a decision about storing them before the user interacts with the banner
  if (areCookiesEnabled() === false) {
    // the cookie may not exist at this point
    // but we should remove it if it does
    Cookies.remove(name);

    return;
  }

  return Cookies.set(name, value, options);
};

export const getCookie = (name: string): string | undefined => {
  // only retreive the cookie if the user has accepted cookies
  if (areCookiesEnabled()) {
    return Cookies.get(name);
  }

  // if the user has rejected cookies or the script hasn't loaded
  // attempt to remove the cookie
  Cookies.remove(name);

  return;
};
